import { HttpParams } from '@angular/common/http';

export const AT_HOME = 1;
export const AT_CENTER = 2;
export const AT_PLATFORM = 3;

export const ALL_BSNS_ID = 0;
export const DOCTOR_CONSULTATION_ID = 10;
export const E_CONSULTATION_ID = 1;
export const FAMILY_DOCTOR_ID = 15;
export const MEDICINES_ID = 2;
export const DIAGNOSTICS_ID = 3;
export const SLEEPAPNEA_ID = 19;
export const FACILITATION_ID = 4;
export const WELLNESS_ID = 14;
export const PACKAGE_ID = 100;
export const PHYSIOTHERAPY_ID = 7;
export const NURSING_ID = 6;
export const BEDSIDE_ID = 8;
export const MEDICAL_EQUIPMENT_ID = 11;
export const SECOND_OPINION_ID = 13;
export const EMOTIONAL_WELLBEING_ID = 12;
export const CARE_AT_HOME_ID = 5;
export const SPECIALITY_ID = 9;
export const PENALTY_BSNS_ID = 999;
export const QUANTELA_COUPON_CODE = 'ECON100';
export const COVID_COUPON_CODE = 'ECONC19';
export const QUANTELA_CORP_ID = '271';
export const CUSTOMER_ROLE = 'customer';
export const CHAT_KEY = 'chat';
export const DOCTOR_LIMIT=30;
export const DOCTOR_OFFSET=0;
export const DEFAULT_BUSINESS_LOCATION = {
  LatVal: 17.445856,
  LngVal: 78.3655792,
  zipcode: '500032',
};
export const APP_DEFAULT_LOCATION = {
  latitude: DEFAULT_BUSINESS_LOCATION.LatVal,
  longitude: DEFAULT_BUSINESS_LOCATION.LngVal,
};

const paramsObj = new HttpParams();
//paramsObj[Symbol.for('nonBlocking')] = true;
export const NO_BLOCK_PARAM = {
  params: paramsObj,
};

export const MAPS_COUNTRY_CODE = 'in';
export const GMAPS_NO_ZIPCODE =
  'We are unable to fetch your location zip code details, please choose other near by address';
export const GMAPS_NO_CITY =
  'We are unable to fetch your location name details, please choose other near by address';

  export const MY_ORDERS :any= {
    cancelButton: 'Cancel order',
    feedbackButton: 'Give Feedback',
    reorderButton: 'Re order',
    resheduleButton: 'Reschedule order',
    showAllPurchasedItems: 'Show all items purchased with this item',
    trackOrder: 'Track Order',
    downloadInvoice: 'Download Invoice',
    sendInvoiceButton: 'Send Invoice to mail', //cco
    sendReport: 'Report Status',
    refundStatusButton: 'Refund Status',
    paymentLinkButton: 'Send Payment Link',//cco
    sendPrescriptionLink: 'Send Upload Prescription Link',//cco
    transferCall: 'Transfer Call',
    extendButton: 'Extend Order',
    refundStatus: 'Refund Status',
    paymentDue: 'Send Payment Link',
    showMap: 'Show Map',
    penaltyStatus: 'Penalty Status',
    reassignDoctor: 'Reassign Doctor',
    showPrescription: 'Show Prescription',
}

export const MY_ORDERS_ICONS :any= {
  // reorderButton: 'assets/icons/testInstructions.svg',
  refundStatus: 'assets/icons/orderIcons/refund_status.svg',
  showMap: 'assets/icons/orderIcons/show_map.svg',
  extendButton: 'assets/icons/orderIcons/extend_order.svg',
  paymentLinkButton: 'assets/icons/orderIcons/send_payment_link.svg',
  trackOrder: 'assets/icons/orderIcons/track_order.svg',
  sendPrescriptionLink: 'assets/icons/orderIcons/send_upload_prescription_link.svg',
  cancelButton: 'assets/icons/orderIcons/cancel_order.svg',
  resheduleButton: 'assets/icons/orderIcons/reschedule_order.svg',
  sendInvoiceButton: 'assets/icons/orderIcons/send_invoice_to_mail.svg',
  downloadInvoice: 'assets/icons/orderIcons/download_invoice.svg',
  reassignDoctor: 'assets/icons/orderIcons/reassign_doctor.svg',
  sendReport: 'assets/icons/orderIcons/report_status.svg',
  penaltyStatus: 'assets/icons/orderIcons/penalty_status.svg',
  showPrescription: 'assets/icons/orderIcons/show_prescription.svg',
  transferCall: 'assets/icons/orderIcons/transfer_call.svg',
}

export const MY_Services :any= {
  'diagnostics_others_tests': 'Diagnostic Services',
  'pathology_lab_tests': 'Lab Tests',
  'radiology_lab_tests': 'X-Ray and Scans',
  'doctor_consultaion': 'Doctor Consultation',
  'medicines': 'Medicines',
  'packages': 'Packages'
}

